<div class="column-container">
  <h4 [matTooltip]="getHeaderTooltip()" matTooltipPosition="right">MODULES</h4>
  <div class="button-column">
    <!-- Wrapper div instead of flex-direction: column - fixes issue where firefox scrollbar cuts off content -->
    <div>
      <div *ngFor="let module of modules">
        <commands-ui-single-module-button
          [module]="module"
          [active]="isActive(module)"
          (click)="toggleActiveModule(module)"
        ></commands-ui-single-module-button>
      </div>
    </div>
  </div>
</div>
